import { styled } from 'styled-components'
import WizrText from '../WizrText'
import WizrButton from '../WizrButton'
import WizrFlexSpacing from '../WizrFlexSpacing'

interface IDeleteFolderForm {
  type?: string
  folderName: string
  folderSize?: any
  onDeleteConfirm?: () => void
  onCancel?: () => void
}

const StyledFlexSpacing = styled(WizrFlexSpacing)`
  .ant-space-item:last-child {
    width: 100% !important;
    align-self: stretch !important;
  }
`

const TextContainer = styled.div`
  background: #fff;
  text-align: left;
  width: 100%;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto;
  padding: 15px 15px 0px 15px;
  width: 100%;
  box-sizing: border-box;
`

const DeleteFolderForm = ({
  type,
  folderName,
  folderSize,
  onDeleteConfirm,
  onCancel,
}: IDeleteFolderForm): JSX.Element => {

  return (
    <StyledFlexSpacing background='#FFF' textAlign='left' alignItems='flex-start'>
      <TextContainer>
        {/* <WizrText type='body1'>Are you sure you want to delete {folderName} ?</WizrText> */}

        {folderSize === 0 ? <WizrText type='body1'>Are you sure you want to delete <b>{folderName}</b>?</WizrText> :
          <WizrText type='body1'> The folder <b>{folderName}</b> you are trying to delete has data, Do you want to proceed?</WizrText>}
      </TextContainer>
      <ButtonContainer>
        <WizrButton type='default' text='Delete' onClick={onDeleteConfirm} style={{ borderRadius: '20px' }} />
        <WizrButton text='Cancel' onClick={onCancel} style={{ borderRadius: '20px' }} />
      </ButtonContainer>
    </StyledFlexSpacing>
  )
}

export default DeleteFolderForm
